var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalearnings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.30554 9.97117H25.1942V7.1091C25.1942 6.90805 25.1105 6.72386 24.9432 6.55653C24.7759 6.3892 24.5917 6.30554 24.3906 6.30554H5.1091C4.90805 6.30554 4.72386 6.3892 4.55653 6.55653C4.3892 6.72386 4.30554 6.90805 4.30554 7.1091V9.97117ZM3 7.1091C3 6.50812 3.20127 6.00635 3.60381 5.60381C4.00635 5.20127 4.50812 5 5.1091 5H24.3906C24.9916 5 25.4934 5.20127 25.8959 5.60381C26.2985 6.00635 26.4997 6.50812 26.4997 7.1091V13.0842H4.30554V21.1685C4.30554 21.3695 4.3892 21.5537 4.55653 21.721C4.72386 21.8884 4.90805 21.972 5.1091 21.972H11.1897V23.2776H5.1091C4.50812 23.2776 4.00635 23.0763 3.60381 22.6738C3.20127 22.2712 3 21.7695 3 21.1685V7.1091ZM18.1994 25.2861L13.5546 20.6414L14.4786 19.7174L18.1994 23.4231L25.626 15.9966L26.55 16.9356L18.1994 25.2861ZM4.30554 7.1091V21.1685C4.30554 21.3695 4.3892 21.5537 4.55653 21.721C4.72386 21.8884 4.90805 21.972 5.1091 21.972H4.30554V16.0217V19.735V6.30554H5.1091C4.90805 6.30554 4.72386 6.3892 4.55653 6.55653C4.3892 6.72386 4.30554 6.90805 4.30554 7.1091Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalearnings);
export default __webpack_public_path__ + "static/media/totalearnings.5dd14b8c311fab7344f6c09af4bde943.svg";
export { ForwardRef as ReactComponent };